import { Crumblist, ICrumb } from '@aon/aon-tws-common-ui';
import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { DistributionContactsModal } from '../../components/audience/distributions/DistributionContactsModal';
import { RowSummaryItem } from '../../components/common';
import { IDistributionContactActionCreators, ISummaryItem, ISurveyParticipantActionCreators, SummaryDisplayType } from '../../models';
import { IApplicationState } from '../../store';
import { ActionCreators as DistributionContactsActionCreators, IDistributionContactState } from '../../store/DistributionContactStore';
import { ISurveyBuilderState } from '../../store/SurveyBuilderStore';
import { ActionCreators as SurveyParticipantActionCreators, ISurveyParticipantState } from '../../store/SurveyParticipantStore';

const CrumblistContainer = styled.div`
	margin-top: 15px;
	max-height: 200px;
	overflow-y: auto;
`;
CrumblistContainer.displayName = 'CrumblistContainer';

export interface IDistributionListSummaryItemProps extends IDistributionContactActionCreators, ISurveyParticipantActionCreators {
	audienceId: number;
	summaryItem: ISummaryItem;
}

const mapStateToProps = (state: IApplicationState, props: IDistributionListSummaryItemProps) => ({
	...state.surveyBuilder,
	...state.distributionContacts,
	...state.surveyParticipants,
	audienceId: props.audienceId,
	summaryItem: props.summaryItem,
});

type DistributionListSummaryItemProps = ISurveyBuilderState &
	IDistributionListSummaryItemProps &
	IDistributionContactState &
	ISurveyParticipantState;

export class DistributionListSummaryItem extends React.Component<DistributionListSummaryItemProps, { contactModalOpen: boolean }> {
	constructor(props: DistributionListSummaryItemProps) {
		super(props);

		this.state = {
			contactModalOpen: false,
		};

		this.toggleDistributionContactsModal = this.toggleDistributionContactsModal.bind(this);
	}

	public render() {
		const { summaryItem } = this.props;
		const hasPopoutList = summaryItem.displayType === SummaryDisplayType.PopOutList;
		return (
			<>
				<RowSummaryItem {...summaryItem} hasPopoutList={hasPopoutList} toggleModal={this.toggleDistributionContactsModal}>
					{hasPopoutList && (
						<DistributionContactsModal
							{...this.props}
							readonly={true}
							isOpen={this.state.contactModalOpen}
							onClose={this.toggleDistributionContactsModal}
						/>
					)}
					{summaryItem.displayType === SummaryDisplayType.TextWithDetails && this.getHierarchyNodeSelection()}
				</RowSummaryItem>
			</>
		);
	}

	private toggleDistributionContactsModal() {
		const isClosing = this.state.contactModalOpen;
		this.setState({ contactModalOpen: !this.state.contactModalOpen });

		if (isClosing) {
			this.props.CloseDistributionContactModal();
		} else {
			this.props.OpenDistributionContactModal();
		}
	}

	private getHierarchyNodeSelection = () => {
		const { summaryItem } = this.props;
		const descendantsIncludedKeys =
			(summaryItem.value && summaryItem.value.details && Object.keys(summaryItem.value.details.descendantsIncluded)) || [];
		const singleIncludedKeys =
			(summaryItem.value && summaryItem.value.details && Object.keys(summaryItem.value.details.singleIncluded)) || [];

		const descendantsIncluded: ICrumb[] = descendantsIncludedKeys.map((key: any) => {
			return {
				displayText: summaryItem.value.details.descendantsIncluded[key].name,
				value: key,
				count: summaryItem.value.details.descendantsIncluded[key].totalRollups,
			};
		});
		const singleIncluded = singleIncludedKeys.map((key: any) => {
			return {
				displayText: summaryItem.value.details.singleIncluded[key].name,
				value: key,
				count: summaryItem.value.details.singleIncluded[key].totalRollups,
			};
		});

		return (
			<CrumblistContainer>
				<Crumblist data={[...descendantsIncluded, ...singleIncluded]} />
			</CrumblistContainer>
		);
	};
}

export const DistributionListSummaryItemContainer: React.ComponentType<any> = connect(mapStateToProps, {
	...DistributionContactsActionCreators,
	...SurveyParticipantActionCreators,
})(DistributionListSummaryItem);
